var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Card from '@Components/Card';
import Logo from '@Assets/Pagito_Logo_white.svg';
import { Typography } from '@mui/material';
var Brand = function () {
    return (_jsxs(Card, __assign({ variant: "outlined", filled: true, width: "450px", sx: {
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '8px 0 0 8px'
        } }, { children: [_jsx("img", { src: Logo, height: 'auto', width: '120px' }), _jsxs("div", __assign({ style: { textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '4px' } }, { children: [_jsx(Typography, __assign({ variant: "h4" }, { children: "Paguito" })), _jsx(Typography, __assign({ variant: "body1" }, { children: "Administra tus finanzas con facilidad" }))] }))] })));
};
export default Brand;
